import React, { useEffect, useState } from 'react'
import MediaQuery from 'react-responsive'
import Scrollchor from 'react-scrollchor'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Article } from '../../types/newsnetApi'

const url = parseHostname().publicationDomain

const aboPlusText = 'ABO+ '

class DownloadError extends Error {}

function handleErrors(response) {
  if (!response.ok) {
    // Something went wrong, throw an error
    throw new DownloadError(
      `Download Error: ${response.status} – ${response.statusText} for ${
        response.url
      }.`
    )
  }

  // If everything is fine, return the response
  return response
}

export const Category = ({
  categorySlug,
  categoryHeader,
  categorySubHeader,
  articleIDs,
  clickHandler
}: {
  categorySlug: string
  categoryHeader: string
  categorySubHeader: string
  articleIDs: string[]
  clickHandler: (e: Event | MouseEvent) => void
}) => {
  const [articleDataList, setArticleDataList] = useState<Article[]>([])

  // Download data
  useEffect(() => {
    // Clean article ID List
    setArticleDataList([])
    articleIDs.forEach(id => {
      window
        .fetch(`https://m.${url}/api/articles/` + id)
        .then(handleErrors)
        .then(res => res.json())
        .then(dataFromTaApi => {
          // console.log(dataFromTaApi.article.lead + ' data');

          window
            .fetch(`https://m.${url}/api/articles/` + id + '/external_services')
            .then(handleErrors)
            .then(res => res.json())
            .then(dataFromTaApi2 => {
              setArticleDataList(prevState => {
                let list = [
                  ...prevState,
                  {
                    dark:
                      (dataFromTaApi2.communities[0] &&
                        dataFromTaApi2.communities[0].count) ||
                      0,
                    facebook:
                      (dataFromTaApi2.communities[1] &&
                        dataFromTaApi2.communities[1].count) ||
                      0,
                    twitter:
                      (dataFromTaApi2.communities[2] &&
                        dataFromTaApi2.communities[2].count) ||
                      0,
                    whatsapp:
                      (dataFromTaApi2.communities[3] &&
                        dataFromTaApi2.communities[3].count) ||
                      0,
                    mail:
                      (dataFromTaApi2.communities[4] &&
                        dataFromTaApi2.communities[4].count) ||
                      0,
                    communitiesComments:
                      (dataFromTaApi2.communities[5] &&
                        dataFromTaApi2.communities[5].count) ||
                      0,

                    pic: dataFromTaApi.article.picture_medium_url,
                    picSquare: dataFromTaApi.article.picture_square_url,
                    title: dataFromTaApi.article.title,
                    teaser: dataFromTaApi.article.lead,
                    ressort: dataFromTaApi.article.category,
                    id: dataFromTaApi.article.legacy_id,
                    canonical_path: dataFromTaApi.article.canonical_path,
                    aboPlus:
                      dataFromTaApi.article.external_services.statistics[2]
                        .premium,
                    autor: dataFromTaApi.article.authors,
                    published: parseInt(
                      dataFromTaApi.article.first_published_at
                    )
                  }
                ]

                return list.sort((a, b) => b.published - a.published)
              })
            })
        })
        .catch(error => {
          // if it's a download error, we will handle it
          if (error instanceof DownloadError) {
            console.warn(error)
          } else {
            // otherwise we rethrow the error
            throw error
          }
        })
    })
  }, [articleIDs])

  return (
    <div className='sectionWrapper'>
      <MediaQuery maxWidth={599}>
        <div className='ui container section'>
          <Scrollchor to='#nav'>
            <div className='titleWrapper'>
              <h2 className='categoryTitle' id={categorySlug}>
                {categoryHeader}
              </h2>
            </div>
            <div className='categorySubtitle'>
              <p className='categorySubHeader'>{categorySubHeader}</p>
              <i className='chevron up icon' />
            </div>
          </Scrollchor>
          <div className='ui inverted divider' />

          <div className='ui three cards doubling stackable'>
            {articleDataList.slice(0, 3).map(c => {
              let authorsString =
                c.autor && c.autor.map(autor => autor.name).join(', ')
              return (
                <a
                  href={`https://${url}` + c.canonical_path}
                  key={categorySlug + ':' + c.id}
                  data-link={c.id}
                  data-category={categorySlug}
                  onClick={clickHandler}
                  className='ui card'
                >
                  <img src={c.pic} className='image' alt='' />
                  <div className='content'>
                    <div className='header'>{c.title}</div>
                    <div className='description'>
                      {c.aboPlus && (
                        <span className='AboPlus'>{aboPlusText}</span>
                      )}
                      {c.teaser.replace(/<\/?p>/gi, '')}
                      <div className='autor'>{authorsString}</div>
                    </div>
                  </div>
                  <div className='extra content'>
                    <div className={'ui horizontal link infographic list'}>
                      <div
                        className={`item ${
                          c.communitiesComments !== 0 ? 'notNull' : 'Null'
                        }`}
                      >
                        <i
                          className='discussions icon'
                          aria-label='Kommentare'
                        />{' '}
                        {c.communitiesComments}
                      </div>
                      <div
                        className={`item
                        ${
                          c.communitiesComments !== 0 ? 'correct' : 'incorrect'
                        }`}
                      >
                        <i
                          className='share alternate icon'
                          aria-label='Shares'
                        />{' '}
                        {c.dark + c.facebook + c.twitter + c.whatsapp + c.mail}
                      </div>
                    </div>
                  </div>
                </a>
              )
            })}
          </div>

          <div className='ui two cards doubling stackable'>
            {articleDataList.slice(3).map(c => {
              let authorsString =
                c.autor && c.autor.map(autor => autor.name).join(', ')
              return (
                <a
                  href={`https://${url}` + c.canonical_path}
                  key={categorySlug + ':' + c.id}
                  data-link={c.id}
                  data-category={categorySlug}
                  onClick={clickHandler}
                  className='ui card'
                >
                  <div className='card small'>
                    <img
                      src={c.picSquare}
                      className='left floated tiny ui image'
                      alt=''
                      style={{ marginBottom: '0' }}
                    />
                    <span className='content'>
                      <div className='header'>{c.title}</div>
                      <div className='meta'>
                        {c.aboPlus && (
                          <span className='AboPlus'>{aboPlusText}</span>
                        )}
                        {/*/ {c.teaser.replace(/<\/?p>/gi, '')} */}
                        <div className='autor'>{authorsString}</div>
                      </div>
                    </span>
                  </div>
                </a>
              )
            })}
          </div>
        </div>
      </MediaQuery>

      <MediaQuery minWidth={600}>
        <div className='ui container section'>
          <Scrollchor to='#nav'>
            <div className='titleWrapper'>
              <h2 className='categoryTitle' id={categorySlug}>
                {categoryHeader}
              </h2>
              <div className='categorySubtitle'>
                {/*<p className='categorySubHeader'>{categorySubHeader}</p>*/}
                <i className='chevron up icon' />
              </div>
            </div>
          </Scrollchor>
          <div className='ui inverted divider' />

          <div className='ui three cards doubling stackable'>
            {articleDataList.map(c => {
            //   console.log('ARTICLEDATA', c)
              let authorsString =
                c.autor && c.autor.map(autor => autor.name).join(', ')
              return (
                <a
                  href={`https://${url}` + c.canonical_path}
                  key={categorySlug + ':' + c.id}
                  data-link={c.id}
                  data-category={categorySlug}
                  onClick={clickHandler}
                  className='ui card'
                >
                  <img src={c.pic} className='image' alt='' />
                  <div className='content'>
                    <div className='header'>{c.title}</div>
                    <div className='description'>
                      {c.aboPlus && (
                        <span className='AboPlus'>{aboPlusText}</span>
                      )}
                      {c.teaser.replace(/<\/?p>/gi, '')}
                      <div className='autor'>{authorsString}</div>
                    </div>
                  </div>
                  <div className='extra content'>
                    <div className={'ui horizontal link infographic list'}>
                      <div
                        className={`item ${
                          c.communitiesComments !== 0 ? 'notNull' : 'Null'
                        }`}
                      >
                        <i
                          className='discussions icon'
                          aria-label='Kommentare'
                        />{' '}
                        {c.communitiesComments}
                      </div>
                      <div
                        className={`item
                        ${
                          c.communitiesComments !== 0 ? 'correct' : 'incorrect'
                        }`}
                      >
                        <i
                          className='share alternate icon'
                          aria-label='Shares'
                        />{' '}
                        {c.dark + c.facebook + c.twitter + c.whatsapp + c.mail}
                      </div>
                    </div>
                  </div>
                </a>
              )
            })}
          </div>
        </div>
      </MediaQuery>
    </div>
  )
}
